import { FloatingPosition } from "@mantine/core";
import { useRef, useState } from "react";

import { colors } from "#app/theme/v1/colors";
import { Box } from "#shared/view/components/Box";
import { Popover } from "#shared/view/components/Popover";

type RichTooltipProps = {
  target: React.ReactNode;
  children: React.ReactNode;
  maw?: number;
  position?: FloatingPosition;
  selectable?: boolean;
};
export const RichTooltip = ({
  target,
  children,
  maw,
  position = "right",
  selectable = false,
}: RichTooltipProps) => {
  const [opened, setOpened] = useState(false);
  const closeTimeout = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    if (closeTimeout.current) {
      clearTimeout(closeTimeout.current);
      closeTimeout.current = null;
    }
    setOpened(true);
  };

  const handleMouseLeave = () => {
    closeTimeout.current = setTimeout(() => {
      setOpened(false);
    }, 100);
  };

  return (
    <Popover position={position} opened={opened} withinPortal onClose={() => setOpened(false)}>
      <Popover.Target>
        <Box onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          {target}
        </Box>
      </Popover.Target>
      <Popover.Dropdown
        style={{
          pointerEvents: selectable ? "auto" : "none",
          padding: 8,
          backgroundColor: colors.gray[9],
          borderColor: colors.gray[9],
          color: "white",
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        maw={maw}
      >
        {children}
      </Popover.Dropdown>
    </Popover>
  );
};
